<template>
    <v-container class="">
        <v-layout row wrap>
            <v-flex sm6 xs6>
                <v-card-text class="headline">
                    Mi Progreso
                </v-card-text>
                <v-card-text >
                    <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="15"
                            :value="progress_total"
                            color="teal"
                    >
                        {{ progress_total }}
                    </v-progress-circular>
                </v-card-text>
            </v-flex>
            <v-flex sm6 xs6>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'progressCourse',
        components: {

        },
        created(){
            this.getUserProgress();
        },
        data(){
            return {
                progress:[],

            }
        },
        computed: {
            ...mapState,
            ...mapGetters([
                'progress_total'
            ]),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            courseId() {
                return JSON.parse(localStorage.getItem('courseId'));
            },

        },
        methods:{
            getUserProgress: function () {
                var url = '/api/v1/getUserProgress';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    course_id  : this.courseId,
                    userId    : this.userId.id,

                }).then(response => {
                    this.progress=response.data;

                    var total= 0;

                    var progress = response.data;
                    Object.keys(progress).forEach(function (key) {
                        total = total + Number(progress[key].value)
                    });

                    this.total_progress = total;
                    this.$store.commit('total_progress', total.toFixed(0));
                })
            }
        }

    }
</script>